import { forwardRef, PropsWithChildren, Ref, useRef } from "react";
import {
  Animated,
  NativeScrollEvent,
  NativeSyntheticEvent,
  SafeAreaView,
  ScrollView,
  StyleProp,
  StyleSheet,
  ViewStyle,
} from "react-native";
import BMView from "../../../components/View/BMView";

type Props = {
  headerContent?: React.JSX.Element;
  footerContent?: React.JSX.Element;
  headerStyle?: StyleProp<ViewStyle>;
  footerStyle?: StyleProp<ViewStyle>;
  contentStyle?: StyleProp<ViewStyle>;
  onScroll?(event: NativeSyntheticEvent<NativeScrollEvent>): void;
  scrollEventThrottle?: number;
  showsHorizontalScrollIndicator?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
};

function StickyContainer(
  {
    scrollEventThrottle = 16,
    showsHorizontalScrollIndicator = false,
    ...props
  }: PropsWithChildren<Props>,
  ref: Ref<ScrollView>
) {
  const {
    headerContent,
    footerContent,
    onScroll,
    children,
    headerStyle,
    footerStyle,
    contentStyle,
    containerStyle,
  } = props;
  const scrollOffsetY = useRef(new Animated.Value(0)).current;
  function handleOnScroll(e: NativeSyntheticEvent<NativeScrollEvent>) {
    Animated.event([{ nativeEvent: { contentOffset: { y: scrollOffsetY } } }], {
      useNativeDriver: false,
    })(e);
    onScroll?.(e);
  }
  return (
    <SafeAreaView style={[styles.container, containerStyle]}>
      <BMView style={headerStyle}>{headerContent}</BMView>
      <ScrollView
        ref={ref}
        style={contentStyle}
        scrollEventThrottle={scrollEventThrottle}
        onScroll={handleOnScroll}
        showsHorizontalScrollIndicator={showsHorizontalScrollIndicator}
      >
        {children}
      </ScrollView>
      <BMView style={footerStyle}>{footerContent}</BMView>
    </SafeAreaView>
  );
}

export default forwardRef(StickyContainer);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    margin: 0,
  },
});
